// --------------------------------------------
// Expanding table display
// --------------------------------------------

function toggleTableExpand() {
  let table = this.closest('.truncate--height');
  if (table) {
    table.classList.toggle('expanded');
  }
  let text = this.querySelector('.expand-btn--text');
  text.textContent =
    text.textContent === 'See More...' ? 'See Less' : 'See More...';
}

let expandButtons = document.querySelectorAll('.expand-btn--target');
expandButtons.forEach((expandButton) => {
  expandButton.addEventListener('click', toggleTableExpand);
});

// --------------------------------------------
// Tab components
// --------------------------------------------

// Find all tab groups on page
// function initTabComponents() {
//     let tabGroups = document.querySelectorAll('[data-component="content-tabs"]');
//     tabGroups.forEach(tabGroup => {
//         initTabFunctionality(tabGroup)
//     })
// }
// Initialize all tab groups and flavor togglers
function initTabComponents() {
  let tabGroups = document.querySelectorAll('[data-component="content-tabs"]');
  tabGroups.forEach((tabGroup) => {
    initTabFunctionality(tabGroup);
  });

  let flavorTogglers = document.querySelectorAll(
    '[data-component="flavor-toggler"]'
  );
  flavorTogglers.forEach((flavorToggler) => {
    flavorToggler.addEventListener('click', function (event) {
      if (!event.target.classList.contains('tab-selected')) {
        changeFlavor(event.target);
      }
    });
  });
}

// Change flavor toggles
function changeFlavor(trigger) {
  let flavorGroup = trigger.parentElement;
  let selected = flavorGroup.querySelectorAll('.tab-selected');
  selected.forEach((element) => {
    element.classList.remove('tab-selected');
  });
  trigger.classList.add('tab-selected');

  let selectedFlavor = trigger.getAttribute('data-flavor');
  let containers = document.querySelectorAll('[data-component="content-tabs"]');
  containers.forEach((container) => {
    container.setAttribute('data-flavor', selectedFlavor);
    updateFlavorContent(container, selectedFlavor);
  });
}

// Update content based on selected flavor
function updateFlavorContent(container, flavor) {
  let gridTable = container.querySelectorAll('.feeding-guide-grid.grid-table');
  if (document.querySelector('.feeding-guide-grid.grid-table.topper')) {
    document
      .querySelector('.feeding-guide-grid.grid-table.topper')
      .classList.remove('topper');
    document
      .querySelector(`.feeding-guide-grid.grid-table.flavor-${flavor}`)
      .classList.add('topper');
  }
  if (gridTable) {
    //gridTable.className = `feeding-guide-grid grid-table flavor-${flavor}`;
    document
      .querySelector('.feeding-guide-grid.grid-table.selected')
      .classList.add('hidden');
    document
      .querySelector('.feeding-guide-grid.grid-table.selected')
      .classList.remove('selected');

    document
      .querySelector(`.feeding-guide-grid.grid-table.flavor-${flavor}`)
      .classList.remove('hidden');
    document
      .querySelector(`.feeding-guide-grid.grid-table.flavor-${flavor}`)
      .classList.add('selected');
  }
}

// Set tab trigger listener
function initTabFunctionality(group) {
  let toggles = group.querySelectorAll('[data-component="toggler"]');
  if (group.getAttribute('data-toggle-type') !== 'non-nest') {
    toggles.forEach((toggler) => {
      toggler.addEventListener('click', function (event) {
        if (!event.target.classList.contains('tab-selected')) {
          changeTab(event.target, group);
        }
      });
    });
  } else {
    toggles.forEach((toggler) => {
      toggler.addEventListener('click', function (event) {
        if (!event.target.classList.contains('tab-selected')) {
          changeNonNestTab(event.target, group);
        }
      });
    });
  }
}

function changeNonNestTab(trigger, parent) {
  if (window.innerWidth < 790) {
    // Check if the screen width is under 790px
    let visible = parent.querySelectorAll('.tab-selected');
    visible.forEach((element) => {
      element.classList.remove('tab-selected');
    });
    trigger.classList.add('tab-selected');
    let targetId = trigger.getAttribute('data-toggle-for');
    let targets = parent.querySelectorAll(`[data-toggled-by="${targetId}"]`);
    targets.forEach((target) => {
      if (target) {
        target.classList.add('tab-selected');
        if (target.dataset.toggledBy === 'topper') {
          parent
            .querySelector('.feeding-guide-grid.grid-table.selected')
            .classList.add('topper');
        } else {
          parent
            .querySelector('.feeding-guide-grid.grid-table.selected')
            .classList.remove('topper');
        }
      }
    });
  }
}

// Change tabs on trigger click
function changeTab(trigger, parent) {
  let visible = parent.querySelectorAll('.tab-selected');
  visible.forEach((element) => {
    element.classList.remove('tab-selected');
  });
  trigger.classList.add('tab-selected');
  let targetId = trigger.getAttribute('data-toggle-for');
  let target = parent.querySelector(`[data-toggled-by="${targetId}"]`);
  if (target) {
    target.classList.add('tab-selected');
  }
}

// Initialize functionality on page loage
document.addEventListener('DOMContentLoaded', initTabComponents);

// Custom form validation

function initFormValidation() {
  let forms = document.querySelectorAll('form[data-form-validate="true"]');
  forms.forEach((element) => {
    formValidationListener(element);
  });
}

function formValidationListener(form) {
  form.addEventListener('change', (event) => {
    if (event.target.matches('input, select, textarea')) {
      validateForm(getRequiredInputs(form), form);
      event.target.classList.toggle('invalid-input', !checkValue(event.target));
    }
  });

  form.addEventListener('keyup', (event) => {
    if (
      event.target.matches('input[type="text"], input[type="email"], textarea')
    ) {
      validateForm(getRequiredInputs(form), form);
    }
  });

  validateForm(getRequiredInputs(form), form);
}

async function handleFormSubmit(event) {
  event.preventDefault();
  event.target.querySelector('.form-status').classList.add('hidden');
  event.target.querySelector('.form-status').classList.remove('submit-error');
  event.target.querySelector(
    'button[type="submit"], input[type="submit"]'
  ).disabled = true;
  event.target
    .querySelector('button[type="submit"], input[type="submit')
    .classList.add('btn--loading');
  const formElement = event.target;
  const formData = new FormData(formElement);
  try {
    const response = await fetch(formElement.action, {
      method: formElement.method,
      body: formData
    });
    if (response.ok) {
      handleFormSubmitted(true, event.target);
    } else {
      handleFormSubmitted(false, event.target);
    }
  } catch (error) {
    handleFormSubmitted(false, event.target);
  }
}

function jsonFormData(formData) {
  const json = {};
  for (const [key, value] of formData.entries()) {
    json[key] = value;
  }
  return json;
}

async function handleJsonForm(event) {
  event.preventDefault();
  event.target.querySelector('.form-status').classList.add('hidden');
  event.target.querySelector('.form-status').classList.remove('submit-error');
  event.target.querySelector(
    'button[type="submit"], input[type="submit"]'
  ).disabled = true;
  event.target
    .querySelector('button[type="submit"], input[type="submit"]')
    .classList.add('btn--loading');
  const formElement = event.target;
  const formData = new FormData(formElement);
  const jsonData = jsonFormData(formData);
  try {
    const response = await fetch(formElement.action, {
      method: formElement.method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonData)
    });
    if (response.ok) {
      if (formElement.id === 'ocean-house-menu') {
        window.location.href =
          'https://cdn.shopify.com/s/files/1/0015/5919/9790/files/ocean-house-pet-menu.pdf';
      }
      handleFormSubmitted(true, event.target);
    } else {
      handleFormSubmitted(false, event.target);
    }
  } catch (error) {
    handleFormSubmitted(false, event.target);
  }
}

function handleFormSubmitted(success, form) {
  let statusBox = form.querySelector('.form-status');
  form.querySelector('button[type="submit"], input[type="submit"]').disabled =
    false;
  form
    .querySelector('button[type="submit"], input[type="submit"]')
    .classList.remove('btn--loading');
  if (success && statusBox) {
    statusBox.innerHTML = `<p>${form.getAttribute('data-success-message')}</p>`;
    statusBox.classList.remove('hidden');
    form.querySelector('.form-content').classList.add('hidden');
  } else if (statusBox) {
    statusBox.innerHtml = `<p>There was an issue submitting your form– please try again.</p>`;
    statusBox.classList.add('submit-error');
    statusBox.classList.remove('hidden');
  }
}

function getRequiredInputs(parent) {
  return parent.querySelectorAll(
    'input:required, select:required, textarea:required'
  );
}

function getFormFields(parent) {
  return parent.querySelectorAll('input, select, textarea');
}

function checkValue(trigger) {
  if (trigger.type !== 'number' && trigger.type !== 'checkbox') {
    return checkTextInput(trigger);
  } else if (trigger.type === 'number') {
    return checkNumberInput(trigger);
  }
}

function checkTextInput(input) {
  let pattern = input.getAttribute('pattern');
  if (input.value) {
    if (pattern) {
      let regex = new RegExp(pattern);
      if (regex.test(input.value)) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  } else if (input.required) {
    return false;
  } else {
    return true;
  }
}

function checkNumberInput(input) {
  let value = parseInt(input.value, 10);
  let meetsMin = validateNumber(value, input.min, 'gte');
  let meetsMax = validateNumber(value, input.max, 'lte');
  return meetsMin && meetsMax;
}

function validateNumber(value, compare, operator) {
  if (!compare) {
    return true;
  } else {
    switch (operator) {
      case 'gte':
        return value >= compare;
      case 'gt':
        return value > compare;
      case 'lte':
        return value <= compare;
      case 'lt':
        return value < compare;
      case 'eq':
        return value === compare;
      default:
        throw new Error('Invalid operator');
    }
  }
}

function validateForm(required, parent) {
  if (
    parent.querySelector('input:focus') &&
    parent
      .querySelector('input:focus')
      .getAttribute('data-extra-validation') === 'true'
  ) {
    submitToggle(parent, false);
    return;
  }
  let requiredLength = required.length;
  let filled = 0;
  let updated = 0;
  let isEdit = parent.getAttribute('data-validate-type') === 'edit';

  for (let field of required) {
    let value = field.value || '';
    let currentValue = field.getAttribute('data-current-value') || '';
    let isFieldFilled = value.trim() !== '';
    let isFieldUpdated =
      isEdit && isFieldFilled && currentValue.trim() !== value;

    if (field.type === 'checkbox') {
      filled += field.checked ? 1 : 0;
    } else if (isFieldFilled) {
      filled++;
      updated += isFieldUpdated ? 1 : 0;
    }
  }

  const checkboxSets = parent.querySelectorAll('[data-checkbox-set]');
  if (checkboxSets.length > 0) {
    const uniqueSets = [];
    checkboxSets.forEach((set) => {
      if (!uniqueSets.includes(set.getAttribute('data-checkbox-set'))) {
        uniqueSets.push(set.getAttribute('data-checkbox-set'));
      }
    });
    if (uniqueSets.length > 0) {
      requiredLength += uniqueSets.length;
      uniqueSets.forEach((set) => {
        const minRequired = parseInt(
          parent
            .querySelector(`[data-checkbox-set="${set}"]`)
            .getAttribute('data-required-min')
        );
        const maxAllowed = parseInt(
          parent
            .querySelector(`[data-checkbox-set="${set}"]`)
            .getAttribute('data-required-max')
        );

        const checkedOptions = parent.querySelectorAll(
          `[data-checkbox-set="${set}"]:checked`
        );
        const uncheckedOptions = parent.querySelectorAll(
          `[data-checkbox-set="${set}"]:not(:checked)`
        );
        if (
          checkedOptions.length >= minRequired &&
          checkedOptions.length <= maxAllowed
        ) {
          filled++;
        }
        if (checkedOptions.length === maxAllowed) {
          uncheckedOptions.forEach((option) => {
            option.disabled = true;
          });
        } else {
          uncheckedOptions.forEach((option) => {
            option.disabled = false;
          });
        }
      });
    }
  }

  let formReady = isEdit
    ? requiredLength === filled && updated > 0
    : requiredLength === filled;
  submitToggle(parent, formReady);
}

function submitToggle(form, state) {
  form.querySelector('button[type="submit"], input[type="submit"]').disabled =
    !state;
}

document.addEventListener('DOMContentLoaded', initFormValidation);

// STICKY CTA FUNCTIONALITY

function initStickyCta() {
  let button = document.getElementById('sticky-cta-button');
  if (!button) {
    button = document.querySelector('.shopify-section.sticky--cta');
  }
  if (button) {
    window.addEventListener('scroll', () => {
      let scrollPosition = window.scrollY;
      let footerElement = document.getElementById('shopify-section-footer');
      // let footerRect = footerElement.getBoundingClientRect();
      let hidePosition = document.body.scrollHeight - 2500;

      if (scrollPosition > 100 && scrollPosition < hidePosition) {
        if (!button.classList.contains('transitioned')) {
          displayCta(button);
        }
      } else {
        if (button.classList.contains('transitioned')) {
          hideCta(button);
        }
      }
    });
  }
}

function displayCta(target) {
  target.classList.add('displayed');
  setTimeout(function () {
    target.classList.add('transitioned');
  }, 10);
}

function hideCta(target) {
  target.classList.remove('transitioned');
  setTimeout(function () {
    target.classList.remove('displayed');
  }, 360);
}

document.addEventListener('DOMContentLoaded', initStickyCta);

// Link Tagging

function handleLinkTagging() {
  const sections = document.querySelectorAll('main > div, main > section');
  const allLinks = document.querySelectorAll('a');

  allLinks.forEach((link) => {
    const section = link.closest('main > div, main > section');
    if (section) {
      const sectionIndex = Array.from(sections).indexOf(section);
      const sectionId = `section-${sectionIndex}`;
      link.setAttribute(
        'data-link-group',
        link.getAttribute('data-link-group') || 'page'
      );
      link.setAttribute(
        'data-link-depth',
        link.getAttribute('data-link-depth') || sectionId
      );
      link.setAttribute(
        'data-link-type',
        link.getAttribute('data-link-type') || 'on-page'
      );
    } else {
      link.setAttribute(
        'data-link-group',
        link.getAttribute('data-link-group') || 'global'
      );
      link.setAttribute(
        'data-link-type',
        link.getAttribute('data-link-type') || 'unsectioned'
      );
    }
  });
}

document.addEventListener('DOMContentLoaded', handleLinkTagging);

// ----------------------------------------------------------------------------------------

// Custom Modals and Drawers

// ----------------------------------------------------------------------------------------

const pageLockClasses = ['js-drawer-open', 'lock-scroll'];
const pageLockTarget = document.querySelector('html');

function togglePageLock(locked) {
  pageLockClasses.forEach((lockClass) => {
    pageLockTarget.classList.toggle(lockClass, locked);
  });
}

function handleModalOpen(target) {
  let modalId = target.getAttribute('data-target-id');
  if (!modalId) {
    let targetParent = target.closest('[data-action="open-modal"]');
    if (!targetParent) return;
    modalId = targetParent.getAttribute('data-target-id');
    if (!modalId) return;
  }
  toggleModalDisplay(
    document.querySelector(`[data-modal-id="${modalId}"]`),
    true
  );
  if (modalId === 'meal-plan') {
    window.location.hash = 'meal-plan';
  }
}

function handleModalClose(target) {
  const modalId = target
    .closest('[data-modal-item]')
    .getAttribute('data-modal-id');
  if (!modalId) return;
  toggleModalDisplay(
    document.querySelector(`[data-modal-id="${modalId}"]`),
    false
  );
  document.dispatchEvent(new CustomEvent('modal:closed', { detail: modalId }));
}

function toggleModalDisplay(modal, shouldDisplay = true) {
  if (!modal) return;
  const delay = shouldDisplay ? 50 : 400;
  const displayClasses = shouldDisplay
    ? ['modal-transition', 'modal-displayed']
    : ['modal-displayed', 'modal-transition'];
  modal.classList.toggle(displayClasses[0], shouldDisplay);

  let handlePageLock =
    modal.classList.contains('inline-modal--content') &&
    shouldDisplay &&
    window.innerWidth > 589
      ? false
      : true;

  if (handlePageLock) {
    togglePageLock(shouldDisplay);
  }
  setTimeout(function () {
    modal.classList.toggle(displayClasses[1], shouldDisplay);
  }, delay);
  const modalId = modal.getAttribute('data-modal-id');
  if (
    (modalId === 'nutrition-quiz' || modalId == 'meal-plan') &&
    !shouldDisplay
  ) {
    history.pushState(
      '',
      document.title,
      window.location.pathname + window.location.search
    );
  }
}

function transformQuizTriggers() {
  const quizTriggers = document.querySelectorAll('a[href="#meal-plan"]');
  if (quizTriggers.length === 0) return;
  quizTriggers.forEach((trigger) => {
    trigger.setAttribute('data-action', 'open-modal');
    trigger.setAttribute('data-target-id', 'meal-plan');
    trigger.href = 'javascript:void(0)';
  });
}

function initModalFunctionality() {
  transformQuizTriggers();
  let modalStateTriggers = document.querySelectorAll(
    '[data-action="open-modal"], [data-action="close-modal"]'
  );
  modalStateTriggers.forEach((trigger) => {
    if (trigger.getAttribute('data-action') === 'open-modal') {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        handleModalOpen(event.target);
      });
    } else {
      trigger.addEventListener('click', (event) => {
        handleModalClose(event.target);
      });
    }
  });
  if (window.location.hash === '#meal-plan') {
    toggleModalDisplay(
      document.querySelector(`[data-modal-id="meal-plan"]`),
      true
    );
  }
}

document.addEventListener('DOMContentLoaded', initModalFunctionality);

// ----------------------------------------------------------------------------------------

// Modal Login Form Handling

// ----------------------------------------------------------------------------------------

function attemptModalLogin(event) {
  event.preventDefault();
  const form = event.target;
  const submitButton = form.querySelector('[type="submit"]');
  submitButton.disabled = true;
  submitButton.value = 'Please wait...';

  let formData = new FormData(form);
  formData.append('form_type', 'customer_login');
  formData.append('utf8', '✓');

  fetch('/account/login', {
    method: 'POST',
    body: formData,
    credentials: 'same-origin',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then((response) => {
      if (response.url === 'https://getjoyfood.com/account') {
        // Login successful
        location.reload(); // Reloads the page
      } else {
        // Login failed
        submitButton.value = 'Sign In';
        submitButton.disabled = false;
        form
          .querySelector('[data-content="error-message"]')
          .classList.add('error--active');
      }
    })
    .catch((error) => {
      // Login error
      console.error('Error:', error);
      submitButton.value = 'Sign In';
      submitButton.disabled = false;
      form
        .querySelector('[data-content="error-message"]')
        .classList.add('error--active');
    });
}

function handleModalLogin() {
  const modalLoginForm = document.getElementById('drawer-login-form');
  if (!modalLoginForm) return;
  modalLoginForm.addEventListener('submit', (event) => {
    attemptModalLogin(event);
  });
}

document.addEventListener('DOMContentLoaded', handleModalLogin);

// ----------------------------------------------------------------------------------------

// Global Cart Change Listener Functionality

// ----------------------------------------------------------------------------------------

(function () {
  // Intercepts all fetch requests and passes them through immediately. Designed to handle custom event dispatching on cart responses
  const fetchData = window.fetch; // Save the original fetch function
  window.fetch = function (...args) {
    // Call the original fetch function
    return fetchData.apply(this, args).then((response) => {
      // After the response is received, check if it was a /cart endpoint request
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (url.includes('/cart')) {
        response
          .clone()
          .text()
          .then((text) => {
            try {
              const data = JSON.parse(text);
              data.endpoint = args[0];
              document.dispatchEvent(
                new CustomEvent('cart:changeDetected', { detail: data })
              );
            } catch (error) {
              //console.error('Failed to parse JSON:', error);
            }
          });
      }
      return response; // Return the original response to ensure normal operation
    });
  };
})();

function parseCartChangeType(endpoint) {
  const endpointMap = {
    '/cart/add.js': 'add',
    '/cart/update.js': 'update',
    '/cart/change.js': 'change',
    '/cart/clear.js': 'clear'
  };
  const matchedKey = Object.keys(endpointMap).find((key) =>
    endpoint.includes(key)
  );
  return matchedKey ? endpointMap[matchedKey] : 'get';
}

function cartChangeHandler(payload) {
  let type = parseCartChangeType(payload.endpoint);
  if (cartChangeHandlers[type]) {
    cartChangeHandlers[type](payload);
  }
}

const cartChangeHandlers = {
  get: async (payload) => {
    document.dispatchEvent(new CustomEvent('cart:reparse'));
    whistleCheck(payload.items);
  },
  change: async (payload) => {
    document.dispatchEvent(new CustomEvent('cart:reparse'));
    whistleCheck(payload.items);
  },
  add: (payload) => {
    document.dispatchEvent(new CustomEvent('cart:itemAdded'));
    const items = payload.items ? payload.items : [payload];
    // handleKlaviyoEvent(items)
    handleWhistleOptions(items);
  }
};

// function parseKlaviyoItem(item) {
//     console.log('item to parse', item);
//     if (item.discounted_price === 0 || item.price === 0) return;

//     return {
//         '$is_session_activity': true,
//         '$use_ip': true,
//         'Brand': item.vendor,
//         'Categories': [item.product_type],
//         'CompareAtPrice': '$0.00',
//         'ImageURL': item.image || '',
//         'Name': item.product_title,
//         'Price': "$" + item.presentment_price,
//         'ProductID': item.product_id,
//         'URL': window.location.href
//     }
// }

// function handleKlaviyoEvent(items) {
//     var _learnq = _learnq || [];

//     items.forEach(item => {
//         if (item.discounted_price > 0 || (!item.discounted_price && item.price > 0)) {
//             const klaviyoItem = parseKlaviyoItem(item);
//             console.log('Klaviyo Item', klaviyoItem);
//             _learnq.push(['track', 'Added to Cart', klaviyoItem]);
//         };
//     })
// }

document.addEventListener('cart:changeDetected', (event) => {
  cartChangeHandler(event.detail);
});

// Code Based GWP Functionality

function checkItemGiftEligiblity(items) {
  const productGiftTriggers =
    items.filter(
      (item) =>
        item.product_id === 7044876435502 &&
        item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan
    ) || null;
  const productEligibile = productGiftTriggers.length > 0 ? true : false;
  return productEligibile;
}

function checkSessionGiftEligibility() {
  let offerDetails = offer ? parseOfferDetails(offer) : null;
  let sessionEligible =
    offerDetails &&
    offerDetails.gifts_with_purchase &&
    offerDetails.gifts_with_purchase.length > 0;
  if (sessionEligible) {
    return offerDetails;
  }

  if (
    offerDetails &&
    !offerDetails.gifts_with_purchase &&
    offerDetails.paired_offer
  ) {
    offerDetails = parseOfferDetails(offerDetails.paired_offer);
    sessionEligible =
      offerDetails &&
      offerDetails.gifts_with_purchase &&
      offerDetails.gifts_with_purchase.length > 0;
    if (sessionEligible) {
      return offerDetails;
    }
  }

  return null;
}

function checkSessionCartGiftEligibility(filtered = true) {
  //let offerDetails = offer ? parseOfferDetails(offer) : null;
  let sessionEligible =
    gwpSet &&
    gwpSet.type === 'cart_threshold' &&
    gwpSet.options &&
    gwpSet.options.length > 0;
  if (sessionEligible) {
    return filtered
      ? gwpSet.options.filter((gift) => gift.gift_item_id)
      : gwpSet.options;
  }

  return null;
}

async function giftHandler(items, subtotal) {
  if (items && items.length === 0) {
    sessionStorage.removeItem('removedGiftItem');
  }
  if (!items || !items.length) return;

  //const productEligibile = checkItemGiftEligiblity(items)
  const productEligibile = false; // Edited for BFCM 2024 updates - PDP FFD no longer getting GWP
  const offerDetails = checkSessionGiftEligibility();
  const cartThresholdEligible = checkSessionCartGiftEligibility(true);

  const sessionEligible = offerDetails ? true : false;

  const inCartGifts = items.filter((item) => {
    const properties = item.properties || {};
    const checkoutBlocksIds = [
      '66b531bc048d6de8b24c9933',
      '66cfcf90d4259dfc94a03391',
      '67326792b6560e1a4fe6fbd0',
      '673267ed7b5065c1f1485bd2'
    ];
    return (
      properties['is_gift'] === 'true' ||
      properties['is_gift'] === true ||
      properties['_is_gift'] === 'true' ||
      (properties['_checkoutblocks'] &&
        checkoutBlocksIds.includes(properties['_checkoutblocks']))
    );
  });

  // Identify and create "master array" of potential gift items
  let potentialGiftItems = [];
  if (
    sessionEligible &&
    offerDetails.gifts_with_purchase &&
    offerDetails.gifts_with_purchase.length > 0
  ) {
    potentialGiftItems = [...offerDetails.gifts_with_purchase];
  }

  if (productEligibile) {
    // HANDLES FFD SPECIFIC GIFTING
    let coveredMatch = potentialGiftItems.find(
      (gift) =>
        gift.gift_item_id === 32597223440430 &&
        gift.qualifiers.trigger_product_ids.includes(7044876435502) &&
        gift.qualifiers.subscription == true
    );
    if (!coveredMatch) {
      potentialGiftItems.push({
        gift_item_id: 32597223440430,
        qualifiers: {
          subscription: true,
          one_time: false,
          trigger_product_ids: [7044876435502],
          trigger_min_qty: 1
        },
        application: {
          add_interval: 1, // Adds a new one every time this interval is reached
          max_qty: 1
        }
      });
    }
  }

  let giftsToAdd = [];
  let giftsToUpdate = {};
  let updateCount = 0;
  let inCartHandled = [];

  if (cartThresholdEligible && cartThresholdEligible.length > 0) {
    const giftSubtotalPrice =
      items
        .filter(
          (item) =>
            item.properties && item.properties['_is_threshold_gift'] === 'true'
        )
        .reduce((total, current) => total + current.discounted_price, 0) * 0.01;
    const giftCardsPrice =
      items
        .filter((item) => item.product_id === 6843372404782)
        .reduce((total, current) => total + current.line_price, 0) * 0.01;
    const adjustedSubtotal = subtotal - giftSubtotalPrice - giftCardsPrice;
    // CHECK ELIGIBILITY OF GIFT ITEMS CURRENTLY IN CART
    if (inCartGifts.length > 0) {
      inCartGifts.forEach((giftInCart) => {
        const matchedSettings = cartThresholdEligible.find(
          (setting) => setting.gift_item_id === giftInCart.id
        );
        if (!matchedSettings || adjustedSubtotal < matchedSettings.threshold) {
          giftsToUpdate[giftInCart.key] = 0;
          updateCount += 1;
        } else if (matchedSettings && giftInCart.quantity > 1) {
          giftsToUpdate[giftInCart.key] = 1;
          updateCount += 1;
        }
        inCartHandled.push(giftInCart.id);
      });
    }
    cartThresholdEligible.forEach((gift) => {
      if (!inCartHandled.includes(gift.gift_item_id)) {
        if (gift.threshold <= adjustedSubtotal) {
          giftsToAdd.push({
            id: gift.gift_item_id,
            quantity: 1,
            properties: {
              _is_threshold_gift: 'true',
              _checkoutblocks: gift.checkout_blocks_id
            }
          });
        }
      }
    });
  } else {
    // Check the gifts currently in cart to make sure there are no duplicates or overages
    inCartGifts.forEach((giftInCart) => {
      let allPotentialEligible = potentialGiftItems.filter(
        (potentialGift) => potentialGift.gift_item_id === giftInCart.id
      );
      let currentlyEligible;
      let match = false;
      if (allPotentialEligible.length === 1) {
        currentlyEligible = allPotentialEligible[0];
      } else if (allPotentialEligible.length > 1) {
        allPotentialEligible.forEach((potentialGift) => {
          if (!match) {
            const nonGifts = items.filter(
              (item) =>
                !item.properties ||
                (!item.properties['_checkoutblocks'] &&
                  !item.properties['_is_gift'] &&
                  !item.properties['is_gift'])
            );
            nonGifts.forEach((line) => {
              if (
                potentialGift.qualifiers.trigger_product_ids.includes(
                  line.product_id
                )
              ) {
                match = true;
                currentlyEligible = potentialGift;
              }
            });
          }
        });
      }
      //let currentlyEligible = potentialGiftItems.find(potentialGift => potentialGift.gift_item_id === giftInCart.id);
      // If it isn't eligible, add to the "update" payload for removal
      if (!currentlyEligible) {
        giftsToUpdate[giftInCart.key] = 0;
        updateCount += 1;
        inCartHandled.push(giftInCart.id);
      } else {
        let qualifierItems = filterQualifiedItems(
          items.filter(
            (item) =>
              !item.properties ||
              (!item.properties['_checkoutblocks'] &&
                !item.properties['_is_gift'] &&
                !item.properties['is_gift'])
          ),
          currentlyEligible
        );
        let qualifierQuantity =
          qualifierItems.length > 0
            ? qualifierItems.reduce(
                (totalQty, currentItem) => totalQty + currentItem.quantity,
                0
              )
            : 0;
        if (qualifierQuantity === 0) {
          giftsToUpdate[giftInCart.key] = 0;
          updateCount += 1;
          inCartHandled.push(giftInCart.id);
        } else {
          let eligibleQuantity = 0;
          if (
            qualifierQuantity >= currentlyEligible.qualifiers.trigger_min_qty
          ) {
            eligibleQuantity += 1;
            qualifierQuantity -= 1;
            let remainderQuantity =
              qualifierQuantity / currentlyEligible.application.add_interval;
            if (remainderQuantity > 0) {
              eligibleQuantity += remainderQuantity;
            }
          }
          if (eligibleQuantity > currentlyEligible.application.max_qty) {
            eligibleQuantity = currentlyEligible.application.max_qty;
          }
          if (eligibleQuantity !== giftInCart.quantity) {
            giftsToUpdate[giftInCart.key] = eligibleQuantity;
            updateCount += 1;
          }
          inCartHandled.push(giftInCart.id);
        }
      }
    });

    // Then, check the potential gifts to see if any more need to be added
    potentialGiftItems.forEach((potentialGift) => {
      if (!inCartHandled.includes(potentialGift.gift_item_id)) {
        let qualifierItems = filterQualifiedItems(items, potentialGift);
        let qualifierQuantity =
          qualifierItems.length > 0
            ? qualifierItems.reduce(
                (totalQty, currentItem) => totalQty + currentItem.quantity,
                0
              )
            : 0;
        if (qualifierQuantity > 0) {
          let eligibleQuantity = 0;
          if (qualifierQuantity >= potentialGift.qualifiers.trigger_min_qty) {
            eligibleQuantity += 1;
            qualifierQuantity -= 1;
            let remainderQuantity =
              qualifierQuantity / potentialGift.application.add_interval;
            if (remainderQuantity > 0) {
              eligibleQuantity += remainderQuantity;
            }
          }
          if (eligibleQuantity > potentialGift.application.max_qty) {
            eligibleQuantity = potentialGift.application.max_qty;
          }
          //40686565949486 is supplemnt gwp from labor day
          const propValue =
            potentialGift.gift_item_id === 40686565949486
              ? '66cfcf90d4259dfc94a03391'
              : '66b531bc048d6de8b24c9933';
          giftsToAdd.push({
            id: potentialGift.gift_item_id,
            quantity: eligibleQuantity,
            properties: {
              _checkoutblocks: propValue
            }
          });
        }
      }
    });
  }

  const ignoreNewGifts = sessionStorage.getItem('removedGiftItem') === 'true';

  return {
    add: !ignoreNewGifts ? giftsToAdd : [],
    update: giftsToUpdate
  };
}

function filterQualifiedItems(items, giftSettings) {
  if (
    giftSettings.qualifiers.subscription &&
    giftSettings.qualifiers.one_time
  ) {
    return items.filter((item) =>
      giftSettings.qualifiers.trigger_product_ids.includes(item.product_id)
    );
  }
  if (giftSettings.qualifiers.subscription) {
    return items.filter(
      (item) =>
        giftSettings.qualifiers.trigger_product_ids.includes(item.product_id) &&
        item.selling_plan_allocation
    );
  }
  return items.filter(
    (item) =>
      giftSettings.qualifiers.trigger_product_ids.includes(item.product_id) &&
      !item.selling_plan_allocation
  );
}

async function addCartGifts(items) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    if (response.ok) {
      // More robust success check
      return await response.json();
    } else {
      console.error('Failed to add gifts:', response.status);
      throw new Error(
        'There was an issue adding your gift to the cart. Please try again.'
      );
    }
  } catch (error) {
    console.error('Error:', error);
    throw error; // Rethrow or handle as needed
  }
}

async function updateCartGifts(updates) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (response.ok) {
      return await response.json();
    } else {
      console.error('Failed to update gifts:', response.status);
      return null; // Explicitly return or throw an error
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

// Whistle-specific cart functionality

function handleWhistleOptions(items) {
  const whistleItem = items.find((item) => item.product_id === 6946700296238);
  if (whistleItem) {
    whistleData.in_cart = whistleData.in_cart
      ? whistleData.in_cart + whistleItem.quantity
      : whistleItem.quantity;
  }
  const giftQualifiedIds = [
    4612542464046, 7042281439278, 4699848278062, 7041842249774
  ];
  const giftEligibleItems = items.filter(
    (item) =>
      giftQualifiedIds.includes(item.product_id) &&
      item.selling_plan_allocation &&
      item.selling_plan_allocation.selling_plan
  );
  if (giftEligibleItems.length > 0) {
    // if ((whistleData && whistleData.credits > 0 && !whistleData.in_cart) || (whistleData && whistleData.credits > 0 && whistleData.in_cart < whistleData.credits)) {
    //     showGiftModal()
    // }
  }
}

function whistleCheck(items) {
  if (!items || items.length === 0) return;
  const whistleIds = [6946700296238];
  const whistleCartItems = items.filter((item) =>
    whistleIds.includes(item.product_id)
  );
  if (whistleCartItems.length === 0) return;
  let whistleQuantity = whistleCartItems.reduce(
    (totalQuantity, item) => totalQuantity + item.quantity,
    0
  );
  whistleData.in_cart = whistleQuantity;
  const eligibleCount = whistleData.credits - whistleData.redeemed;
  if (eligibleCount < whistleQuantity) {
    let toRemove = whistleQuantity - eligibleCount;
    parseWhistleRemoval(whistleCartItems.reverse(), whistleQuantity, toRemove);
  }
  let mealItemIds = [
    4699848278062, 4612542464046, 7042281439278, 7041842249774
  ];
  let mealSubscriptionItem = items.find(
    (item) =>
      mealItemIds.includes(item.product_id) &&
      item.selling_plan_allocation &&
      item.selling_plan_allocation.selling_plan
  );
  if (!mealSubscriptionItem && !customerTags.includes('Whistle Eligible')) {
    parseWhistleRemoval(
      whistleCartItems.reverse(),
      whistleQuantity,
      whistleQuantity
    );
  }
  let whistleAdd = document.querySelector('[data-whistle-add-btn]');
  if (whistleAdd) {
    whistleAdd.disabled = eligibleCount <= whistleQuantity;
    let textAttribute = whistleAdd.disabled
      ? 'data-alternate-text'
      : 'data-default-text';
    whistleAdd.textContent = whistleAdd.getAttribute(textAttribute);
  }
  let whistleQty = document.querySelector('[data-whistle-quantity]');
  if (whistleQty && eligibleCount > whistleQuantity) {
    whistleQty.max = eligibleCount - whistleQuantity;
  }
}

function showGiftModal() {
  toggleModalDisplay(
    document.querySelector(`[data-modal-id="gift-with-purchase"]`),
    true
  );
  const cartForm = document.getElementById('CartDrawerForm');
  if (cartForm) {
    cartForm.querySelector('.js-drawer-close').click();
  }
  setTimeout(function () {
    togglePageLock(true);
  }, 300);
}

function parseWhistleRemoval(items, quantity, toRemove) {
  let updates = {};
  for (let i = 0; i < items.length; i++) {
    if (toRemove > 0) {
      let item = items[i];
      let currentQty = item.quantity;
      let newQty = currentQty >= toRemove ? currentQty - toRemove : 0;
      updates[item.key] = newQty;
      toRemove = currentQty >= toRemove ? 0 : toRemove - currentQty;
    } else {
      break;
    }
  }
  removeWhistleItems({ updates: updates }, quantity);
}

async function removeWhistleItems(updates, quantity) {
  await fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify(updates),
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    }
  })
    .then((response) => {
      whistleData.in_cart = quantity;
      document.dispatchEvent(new Event('cart:whistleChange'));
      document.dispatchEvent(new Event('cart:build'));
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function handleWhistleCloseCart() {
  if (!window.location.href.includes('tracking-collar')) {
    window.location.href = 'https://getjoyfood.com/products/tracking-collar';
    return;
  }
  document
    .getElementById('CartDrawerForm')
    .querySelector('.js-drawer-close')
    .click();
}

function handleSmsToggle(trigger, form) {
  form
    .querySelector('[data-set-for="gift-mobile-phone"]')
    .classList.toggle('hidden', !trigger.checked);
  validateGiftForm(form);
}

function handleGiftButtonState(form, ready) {
  const button = form.querySelector('button[type="submit"]');
  button.disabled = !ready;
  button.textContent = ready
    ? button.getAttribute('data-ready-text')
    : button.getAttribute('data-disabled-text');
}

function validateGiftForm(form) {
  let meetsSelectionRequirements =
    form.querySelector('[name="gift-type"]:checked') &&
    form.querySelector('[name="gift-size"]:checked');
  let meetsSmsRequirements = form.querySelector('[name="gift-sms-updates"]')
    .checked
    ? form.querySelector('[name="gift-mobile-phone"]').value !== ''
    : true;
  handleGiftButtonState(
    form,
    meetsSelectionRequirements && meetsSmsRequirements
  );
}

function handleGiftTypeToggle(value, form) {
  const deviceSelected =
    value === 'Tracking Collar' || value === 'Tracking Device';
  const clipSelected = value === 'Tracking Device';
  form
    .querySelector('[data-set-for="gift-size"]')
    .classList.toggle('hidden', !deviceSelected);

  const options = form.querySelectorAll('input[name="gift-size"]');
  options.forEach((option) => {
    const isOneSize = option.value === 'One-size';

    if (!deviceSelected) {
      option.checked = false;
      option.disabled = true;
    } else {
      option.disabled = clipSelected ? !isOneSize : isOneSize;
      option.checked = clipSelected && isOneSize;
    }
  });
  validateGiftForm(form);
}

const giftFormChangeRoutes = {
  'gift-type': (trigger, form) => {
    handleGiftTypeToggle(trigger.value, form);
  },
  'gift-sms-updates': (trigger, form) => {
    handleSmsToggle(trigger, form);
  }
};

function handleGiftFormChange(event, form) {
  const trigger = event.target;
  if (!trigger || !trigger.name) return;
  if (giftFormChangeRoutes[trigger.name]) {
    giftFormChangeRoutes[trigger.name](trigger, form);
  } else {
    validateGiftForm(form);
  }
}

function initGiftForm() {
  const whistleModal = document.querySelector(
    '[data-modal-id="gift-with-purchase"]'
  );
  if (!whistleModal) return;
  const form = whistleModal.querySelector('form');
  if (!form) return;
  form.addEventListener('input', (event) => {
    handleGiftFormChange(event, form);
  });
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    handleGiftFormSubmit(event);
  });
  document.getElementById('skip-whistle').addEventListener('click', (event) => {
    handleWhistleModalClose(
      form
        .querySelector('button[type="submit"]')
        .getAttribute('data-submit-action')
    );
  });
}

function parseGiftVariantId(type, size) {
  if (type === 'Tracking Device') {
    return 40599968055342;
  }
  if (size === 'XS/S') {
    return 40599967825966;
  }
  if (size === 'S/M') {
    return 40599967858734;
  }
  return 40599967891502;
}

async function handleGiftFormSubmit(event) {
  const form = event.target;
  const button = event.submitter;
  const action = button.getAttribute('data-submit-action');

  const variantId = parseGiftVariantId(
    form.querySelector('[name="gift-type"]:checked').value,
    form.querySelector('[name="gift-size"]:checked').value
  );

  let data = {
    id: variantId,
    quantity: 1
  };

  if (form.querySelector('[name="gift-sms-updates"]').checked) {
    data.properties = {
      'Mobile Phone': form.querySelector('[name="gift-mobile-phone"]').value,
      'SMS Update Opt-In': 'Yes'
    };
  }

  await addWhistleGift(form, [data], action);
}

async function addWhistleGift(form, items, action) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    if (response.status === 200) {
      const data = await response.json();
      handleGiftAdded(form, data, action); // Call on success
      return data;
    } else {
      resetGiftForm(form);
      alert(
        'There was an issue adding your gift to the cart. Please try again.'
      );
      return null; // Explicitly return or throw an error
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

function handleGiftAdded(form, data, action) {
  resetGiftForm(form);
  handleWhistleModalClose(action);
  if (action === 'checkout') {
    window.location.href = '/checkout';
    return;
  }
  if (action === 'add' && document.querySelector('[data-slide-id="results"]')) {
    hideSlide(document.querySelector('[data-slide-id="results"]'));
    setTimeout(
      displaySlide(document.querySelector(`[data-slide-id="added-reset"]`)),
      STD_DELAY
    );
    setTimeout(function () {
      regressToStart();
    }, XXL_DELAY);
    return;
  }
  document.dispatchEvent(new Event('cart:whistleChange'));
  document.dispatchEvent(new Event('cart:build'));
  document.dispatchEvent(new Event('cart:open'));
  return;
}

function handleWhistleModalClose(action) {
  toggleModalDisplay(
    document.querySelector(`[data-modal-id="gift-with-purchase"]`),
    false
  );
  if (action === 'checkout') {
    if (document.getElementById('nutrition-quiz')) {
      resetQuiz('to-checkout', false);
    }
    if (document.getElementById('checkout-loader')) {
      initCheckout();
    } else {
      setTimeout(function () {
        window.location.href = '/checkout';
      }, 1);
    }
    return;
  }
  if (action === 'add' && document.querySelector('[data-slide-id="results"]')) {
    hideSlide(document.querySelector('[data-slide-id="results"]'));
    setTimeout(
      displaySlide(
        document.querySelector(`[data-slide-id="reset-whistle-skip"]`)
      ),
      STD_DELAY
    );
    setTimeout(function () {
      regressToStart();
    }, XXL_DELAY);
    return;
  }
  setTimeout(function () {
    document.querySelector('.js-drawer-open-cart').click();
  }, 300);
}

function resetGiftForm(form) {
  form.reset();
  form.querySelector('[data-set-for="gift-size"]').classList.add('hidden');
  form
    .querySelector('[data-set-for="gift-mobile-phone"]')
    .classList.add('hidden');
  document.getElementById('claim-gift-submit').disabled = true;
  document.getElementById('claim-gift-submit').textContent = document
    .getElementById('claim-gift-submit')
    .getAttribute('data-disabled-text');
}

//document.addEventListener('DOMContentLoaded', initGiftForm);

// Global Phone Input Validation

function basicPhoneValidation(event) {
  let value = event.target.value;
  let newValue = value.replace(/[^0-9+\-() ]/g, '');
  event.target.value = newValue;
}

function phoneValidationListener() {
  const phoneInputs = document.querySelectorAll(
    '[data-field-validation="phone"]'
  );
  if (phoneInputs.length === 0) return;
  phoneInputs.forEach((input) => {
    input.addEventListener('input', (event) => {
      basicPhoneValidation(event);
    });
  });
}

document.addEventListener('DOMContentLoaded', phoneValidationListener);

// ----------------------------------------------------------------------------------------

// Compare image component

// ----------------------------------------------------------------------------------------

function findCompareComponents() {
  const compareComponents = document.querySelectorAll(
    '[data-content="compare-component"]'
  );
  if (compareComponents.length === 0) return;
  compareComponents.forEach((component) => {
    enableCompareComponents(component);
    component
      .querySelector('.compare-slider--element')
      .dispatchEvent(new Event('input'));
  });
}

function enableCompareComponents(component) {
  const slider = component.querySelector('.compare-slider--element');

  slider.addEventListener('input', (event) => {
    updateSlider(event, component);
  });
  slider.addEventListener('change', (event) => {
    updateSlider(event, component);
  });
}

function updateSlider(event, component) {
  const basePosition = event.target.value * 0.1;
  const adjustRatio = (((basePosition - 50) * 0.01) / 2) * 20;
  const position = basePosition - adjustRatio;
  component.querySelector('.compare-after--wrapper').style.width =
    position + '%';
  //component.querySelector('.slider-element--button').style.left = `calc(${position}% - 18px)`;
}

document.addEventListener('DOMContentLoaded', findCompareComponents);

// ----------------------------------------------------------------------------------------

// Modalify Quiz

// ----------------------------------------------------------------------------------------

function showQuizModal() {
  toggleModalDisplay(
    document.querySelector('[data-modal-id="nutrition-quiz"]'),
    true
  );
  togglePageLock(true);
}

function initQuizModals() {
  const quizTriggers = document.querySelectorAll('a[href="#nutrition-quiz"]');
  if (quizTriggers.length === 0) return;
  quizTriggers.forEach((trigger) => {
    trigger.addEventListener('click', showQuizModal);
  });
  if (window.location.hash === '#nutrition-quiz') {
    showQuizModal();
  }
}

document.addEventListener('DOMContentLoaded', initQuizModals);

// ----------------------------------------------------------------------------------------

// Anchor link scroll handling updates

// ----------------------------------------------------------------------------------------

function initAnchorHandler() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach((link) => {
    link.addEventListener('click', handleAnchorClick);
  });
}

function handleAnchorClick() {
  setTimeout(function () {
    document.querySelector('body').style.removeProperty('overflow');
  }, 1000);
}

document.addEventListener('DOMContentLoaded', initAnchorHandler);

// ----------------------------------------------------------------------------------------

// Autoscroll component

// ----------------------------------------------------------------------------------------

// function enableAutoscroller(parent) {
//   parent.setAttribute('data-scroller-active', true);

//   const wrapper = parent.querySelector('.scroll-items--wrapper');
//   const items = Array.from(wrapper.children);

//   for (let i = 0; i < 2; i++) {
//     items.forEach((item) => {
//       const duplicate = item.cloneNode(true);
//       duplicate.setAttribute('aria-hidden', true);
//       wrapper.appendChild(duplicate);
//     });
//   }
// }

// function initAutoscrollers() {
//   const components = document.querySelectorAll(
//     '[data-content-type="autoscroll-section"]',
//   );
//   if (components.length === 0) return;

//   components.forEach((component) => {
//     enableAutoscroller(component);
//   });
// }

// document.addEventListener('DOMContentLoaded', initAutoscrollers);

// ----------------------------------------------------------------------------------------

// Quick Add to Cart Functionality

// ----------------------------------------------------------------------------------------

function initQuickAddButtons() {
  const buttons = document.querySelectorAll('[data-action="quick-add"]');
  if (buttons.length === 0) return;

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      handleQuickAdd(event.target);
    });
  });
}

async function handleQuickAdd(trigger) {
  let variantIds = trigger.getAttribute('data-variant-id');
  if (!variantIds) {
    const currentVariant = document
      .querySelector('[data-current-variant]')
      .getAttribute('data-current-variant');
    if (!currentVariant) return;
    variantIds = currentVariant;
  }
  variantIds = variantIds.split(',');

  const data = [];
  variantIds.forEach((variantId) => {
    data.push({
      id: parseInt(variantId),
      quantity: 1
    });
  });

  await addVariantToCart(data);
}

async function addVariantToCart(data) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: data })
    });

    if (response.status === 200) {
      const data = await response.json();
      document.dispatchEvent(new Event('cart:build'));
      document.dispatchEvent(new Event('cart:open'));
      return data;
    } else {
      alert(
        'There was an issue adding your item to the cart. Please try again.'
      );
      return null; // Explicitly return or throw an error
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

document.addEventListener('DOMContentLoaded', initQuickAddButtons);

// ----------------------------------------------------------------------------------------

// Global Cart Fetch

// ----------------------------------------------------------------------------------------

async function getCartItems() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch order items:', error);
    throw error; // Rethrow the error if you need to handle it where getOrderItems is called.
  }
}

// ----------------------------------------------------------------------------------------

// Video carousel component

// ----------------------------------------------------------------------------------------

function displayGalleryContentModal(targetId) {
  let modalTarget = document.querySelector(
    `[data-content-for="modal-${targetId}"]`
  );
  if (!modalTarget) return;

  const html = document.querySelector('html');
  html.classList.add('js-drawer-open');
  html.classList.add('lock-scroll');

  modalTarget.classList.add('visible');
  modalTarget.classList.add('show-modal');
  let video = modalTarget.querySelector('video');
  if (video) {
    video.play();
  }
}

function hideGalleryContentModal() {
  let target = this.closest('.content-modal-wrapper');
  target.classList.remove('show-modal');

  const html = document.querySelector('html');
  html.classList.remove('js-drawer-open');
  html.classList.remove('lock-scroll');

  let video = target.querySelector('video');
  if (video) {
    video.pause();
  }
  setTimeout(function () {
    target.classList.remove('visible');
  }, 200);
}

// function initCarouselGallery() {
//   theme.sections = new theme.Sections();
//   theme.sections.register('videosCarousel', theme.VideosCarousel);

//   let myCarousel = new theme.VideosCarousel(
//     document.querySelector('.video-carousel--section'),
//   );

//   let closeModalButtons = document.querySelectorAll(
//     '[data-close-action="modal"]',
//   );
//   closeModalButtons.forEach((closeButton) => {
//     closeButton.addEventListener('click', hideGalleryContentModal);
//   });
//   const videoContainers = document.querySelectorAll('.video-content-container');

//   // Autoplay videos on hover
//   videoContainers.forEach((videoContainer) => {
//     videoContainer.addEventListener('mouseenter', () => {
//       videoContainer.querySelector('video').play();
//     });
//     videoContainer.addEventListener('mouseleave', () => {
//       videoContainer.querySelector('video').pause();
//     });
//   });
// }

// document.addEventListener('DOMContentLoaded', initCarouselGallery);

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = document.querySelector(
      `[data-section-id="${event.detail.sectionId}"]`
    );
    if (
      section &&
      section.getAttribute('data-section-type') === 'video-carousel'
    ) {
      // initCarouselGallery();
    }
  });
}

// ----------------------------------------------------------------------------------------

// FAQ Search Filtering

// ----------------------------------------------------------------------------------------

function initFaqFilters() {
  const faqSections = document.querySelectorAll('.filtered-faq--section');
  if (faqSections.length === 0) return;

  faqSections.forEach((section) => {
    initFaqFiltering(section);
  });
}

function initFaqFiltering(section) {
  const filterInputs = section.querySelectorAll(
    '[data-input-type="search-filter"]'
  );
  if (filterInputs.length === 0) return;

  const clearButtonReset = section.querySelector('.clear-button-result');
  const clearButton = section.querySelector('.clear-button');
  const filterIconMobile = section
    .querySelector('.searchbar-filter-icon')
    .closest('div');
  const filtersMobile = section.querySelector('.filters-mobile');
  const filterBar = section.querySelector('.filter-bar');
  const tagDisplayContainer = section.querySelector('.tag-display-container');
  const tagsContainer = section.querySelector('.tags-container');
  const searchbarLabelMobile = section.querySelector(
    '.searchbar--label-mobile'
  );
  const tagsIconMobile = tagsContainer.closest('div');

  filterInputs.forEach((input) => {
    input.addEventListener('input', (event) => {
      handleFiltering(event, section);
    });
  });

  [clearButtonReset, clearButton].forEach((button) => {
    button.addEventListener('click', () =>
      selectorsReset(filterInputs, clearButton, section)
    );
  });

  filterIconMobile.addEventListener('click', () => {
    toggleMobileFilters(true);
  });

  tagsIconMobile.addEventListener('click', () => {
    toggleMobileFilters(false);
  });

  checkUrlQuery();

  function toggleMobileFilters(showFilters) {
    filtersMobile.classList.toggle('filter-icon-clicked', showFilters);
    filterBar.classList.toggle('input-mobile-hidden', !showFilters);
    filterBar.classList.toggle('fade-in', showFilters);
    tagDisplayContainer.classList.toggle('mobile-hidden', showFilters);
    filterIconMobile.classList.toggle('mobile-hidden', showFilters);
    tagsContainer.classList.toggle('tags-container-hidden', !showFilters);
    tagsContainer.classList.toggle('tags-container-show', showFilters);
    if (!showFilters) {
      searchbarLabelMobile.classList.add('fade-in');
    }
  }
}

function checkUrlQuery() {
  const url = new URL(window.location.href);
  const currentTerm = url.searchParams.get('term');
  if (currentTerm) {
    const filterInputs = document.querySelectorAll(
      '[data-input-type="search-filter"]'
    );
    const inputEvent = new Event('input', {
      bubbles: true,
      cancelable: true
    });
    filterInputs.forEach((input) => {
      input.value = currentTerm;
      input.dispatchEvent(inputEvent);
    });
  }
}

function selectorsReset(filterInputs, clearButton, section) {
  filterInputs.forEach((input) => {
    input.value = '';
  });

  updateUrlQuery(null);
  resetFilters(section);
  filterByGroups(null, section);

  section
    .querySelector('[data-content="faq-content-message"]')
    .classList.add('visibility-hidden');
  section.querySelector('.clear-button').classList.add('visibility-hidden');
  clearButton.classList.remove('fade-in');

  section.querySelector('.no-result-message').classList.add('hidden');
}

function updateSearchLink(term) {
  document
    .querySelectorAll('[data-content="site-search-link"]')
    .forEach((link) => {
      let linkArray = link.href.split('&q=');
      link.href = `${linkArray[0]}&q=${term}`;
    });
}

function updateUrlQuery(term) {
  const newUrl = new URL(window.location.href);

  if (term) {
    newUrl.searchParams.set('term', term);
  } else {
    newUrl.searchParams.delete('term');
  }

  history.pushState(null, '', newUrl.toString());
}

function handleFiltering(event, section) {
  const term = event.target.value.trim().toLowerCase();
  const valueLength = term.length;
  const clearButton = section.querySelector('.clear-button');
  const dynamicMessage = section.querySelector(
    '[data-content="faq-content-message"]'
  );

  updateSearchLink(term);
  updateUrlQuery(term);

  if (valueLength < 3) {
    clearButton.classList.add('visibility-hidden');
    clearButton.classList.remove('fade-in');

    if (valueLength > 0) {
      dynamicMessage.textContent = `Enter ${3 - valueLength} more letters to filter results.`;
      dynamicMessage.classList.remove('visibility-hidden');
      dynamicMessage.classList.add('fade-in');
    } else {
      dynamicMessage.classList.add('visibility-hidden');
      dynamicMessage.classList.remove('fade-in');
    }
  } else {
    clearButton.classList.remove('visibility-hidden');
    clearButton.classList.add('fade-in');
    dynamicMessage.classList.add('visibility-hidden');
    dynamicMessage.classList.remove('fade-in');
  }

  if (valueLength === 0) {
    resetFilters(section);
    filterByGroups(null, section);
    section.querySelector('.no-result-message').classList.add('hidden');
  } else if (valueLength > 2) {
    filterByGroups(event, section);
  }
}

function filterByGroups(event, section) {
  let noMatch = true;
  const elementToSearch = event ? event.target.value.trim().toLowerCase() : '';
  const groups = section.querySelectorAll('.relativize');

  groups.forEach((group) => {
    const title = group.querySelector('.category-type-title');
    let groupHasMatch = title.textContent
      .toLowerCase()
      .includes(elementToSearch);

    if (!groupHasMatch) {
      const questions = group.querySelectorAll('.faq-question--text');
      questions.forEach((question) => {
        const parentGroup = question.closest('div');
        const answer = parentGroup.querySelector(
          '.collapsible-content__inner--faq'
        );
        const visible =
          question.textContent.toLowerCase().includes(elementToSearch) ||
          answer.textContent.toLowerCase().includes(elementToSearch);

        if (visible) {
          parentGroup.classList.remove('hidden', 'visibility-hidden');
          parentGroup.classList.add('fade-in');
          noMatch = false;
          groupHasMatch = true;
        } else {
          parentGroup.classList.add('hidden', 'visibility-hidden');
          parentGroup.classList.remove('fade-in');
        }
      });
    } else {
      noMatch = false;
    }

    if (!groupHasMatch) {
      group.classList.add('visibility-hidden');
      group.classList.add('hidden');
      group.classList.remove('fade-in');
      //   setTimeout(() => {
      //     group.classList.add('hidden');
      //     group.classList.remove('fade-in');
      //   }, 500);
    } else {
      group.classList.remove('hidden', 'visibility-hidden');
      group.classList.add('fade-in');
    }
  });

  section
    .querySelector('.no-result-message')
    .classList.toggle('hidden', !noMatch);
}

function resetFilters(section) {
  const questions = section.querySelectorAll('.faq-question--text');

  questions.forEach((question) => {
    const group = question.closest('div');
    group.classList.remove('hidden', 'visibility-hidden');
    group.classList.add('fade-in');
  });
}

document.addEventListener('DOMContentLoaded', initFaqFilters);

// ----------------------------------------------------------------------------------------

// Custom Animation Handling

// ----------------------------------------------------------------------------------------

function initAnimationHandler() {
  const animatedElements = document.querySelectorAll('[data-animation-type]');

  if (animatedElements.length === 0) return;

  const onVisibleTargets = document.querySelectorAll(
    '[data-animation-type="on-visible"]'
  );
  const onVisibleFadeTargets = document.querySelectorAll(
    '[data-animation-type="on-visible"][data-animation-class="fade-in"]'
  );
  onVisibleFadeTargets.forEach((element) => {
    if (!element.hasAttribute('data-animation-complete')) {
      element.style.opacity = 0;
    }
  });

  const animations = {
    typewriter: (element) => {
      const text = element.textContent;
      element.textContent = '';
      let index = 0;
      const speed = 25;

      function typeWriter() {
        if (index < text.length) {
          element.textContent += text.charAt(index);
          index++;
          setTimeout(typeWriter, speed);
        } else {
          element.classList.add('blink');
          setTimeout(() => {
            element.classList.add('finished');
          }, 1700);
        }
      }

      typeWriter();
    },
    'fade-in': (element) => {
      element.style.opacity = 1;
      element.setAttribute('data-animation-complete', 'true');
    },
    'chart-animation': (element) => {
      console.log('init animation for', element);
      // INSERT CHART ANIMATION CODE HERE
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const animationClass = entry.target.getAttribute(
          'data-animation-class'
        );
        if (animations[animationClass]) {
          animations[animationClass](entry.target);
        }
        observer.unobserve(entry.target);
      }
    });
  });

  onVisibleTargets.forEach((element) => {
    observer.observe(element);
  });
}

document.addEventListener('DOMContentLoaded', initAnimationHandler);

// ----------------------------------------------------------------------------------------

// New Ingredients Section (with image toggling)

// ----------------------------------------------------------------------------------------

function initProductsPanels() {
  const toggles = document.querySelectorAll(
    '[data-action="toggle-product-content"]'
  );
  if (toggles.length === 0) return;

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      handleProductToggle(event);
    });
  });
}

function handleProductToggle(event) {
  const target = event.target;
  if (target.classList.contains('tab-selected')) return;

  const groupID = target.getAttribute('data-group-id');
  if (!groupID) return;

  const parent = event.target.closest('.ingredients-content--wrapper');
  const flavors = parent.querySelectorAll('.toggle--wrapper .tab--toggle');
  const ingredients = parent.querySelectorAll('.ingredients-group--wrapper');

  flavors.forEach((flavor) => {
    if (flavor.classList.contains(`${groupID}`)) {
      flavor.classList.remove('hidden');
    } else {
      flavor.classList.add('hidden');
    }
  });

  parent
    .querySelector('.product.tab-selected')
    .classList.remove('tab-selected');
  event.target.classList.add('tab-selected');
  parent
    .querySelector('.toggle--wrapper .tab--toggle.tab-selected')
    .classList.remove('tab-selected');
  parent
    .querySelector('.toggle--wrapper .tab--toggle:not(.hidden)')
    .classList.add('tab-selected');

  const flavorSelected = parent
    .querySelector('.toggle--wrapper .tab--toggle.tab-selected')
    .getAttribute('data-group-id');

  ingredients.forEach((ingredient) => {
    if (flavorSelected == ingredient.getAttribute('data-group-id')) {
      ingredient.classList.add('visible');
      ingredient.classList.add('transitioned');
    } else {
      ingredient.classList.remove('visible');
      ingredient.classList.remove('transitioned');
    }
  });
  updateLeftImage();
}

function initIngredientPanels() {
  const toggles = document.querySelectorAll(
    '[data-action="toggle-ingredient-content"]'
  );
  if (toggles.length === 0) return;

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      handleIngredientToggle(event);
    });
  });
}

function handleIngredientToggle(event) {
  const target = event.target;
  if (target.classList.contains('tab-selected')) return;

  const groupID = target.getAttribute('data-group-id');
  if (!groupID) return;

  const parent = target.closest('[data-content="ingredient-toggler"]');

  const parentHeight = parent.offsetHeight;
  if (window.innerWidth > 767) {
    parent.style.height = `${parentHeight}px`;
  }

  const visibleIngredientsHeight = parent.querySelector(
    '.ingredients-group--wrapper.visible.transitioned'
  )
    ? parent.querySelector('.ingredients-group--wrapper.visible.transitioned')
        .offsetHeight
    : 0;
  const visibleListHeight = parent.querySelector(
    '.ingredient-list--wrapper.visible.transitioned'
  )
    ? parent.querySelector('.ingredient-list--wrapper.visible.transitioned')
        .offsetHeight
    : 0;
  const parentBaseHeight =
    parentHeight - visibleIngredientsHeight - visibleListHeight;

  parent
    .querySelector('.toggle--wrapper .tab-selected')
    .classList.remove('tab-selected');
  event.target.classList.add('tab-selected');

  const currentElements = parent.querySelectorAll('.visible.transitioned');
  currentElements.forEach((element) => {
    toggleIngredientState('hide', element);
  });

  setTimeout(function () {
    const targets = parent.querySelectorAll(`[data-group-id="${groupID}"]`);
    targets.forEach((target) => {
      toggleIngredientState('show', target);
    });
  }, 160);

  if (window.innerWidth > 767) {
    setTimeout(function () {
      const targetIngredientsHeight = parent.querySelector(
        `.ingredients-group--wrapper[data-group-id="${groupID}"]`
      )
        ? parent.querySelector(
            `.ingredients-group--wrapper[data-group-id="${groupID}"]`
          ).offsetHeight
        : 0;
      const targetListHeight = parent.querySelector(
        `.ingredient-list--wrapper[data-group-id="${groupID}"]`
      )
        ? parent.querySelector(
            `.ingredient-list--wrapper[data-group-id="${groupID}"]`
          ).offsetHeight
        : 0;
      const targetHeight =
        targetIngredientsHeight + targetListHeight + parentBaseHeight;
      parent.style.height = `${targetHeight}px`;
      setTimeout(function () {
        parent.style.height = `auto`;
      }, 160);
    }, 320);
  }
}

function toggleIngredientState(state, element) {
  const firstClass = state === 'show' ? 'visible' : 'transitioned';
  const secondClass = state === 'show' ? 'transitioned' : 'visible';

  const animationDuration =
    parseInt(element.getAttribute('data-animation-duration')) + 10;

  element.classList.toggle(firstClass);
  setTimeout(function () {
    element.classList.toggle(secondClass);
  }, animationDuration);
}

function updateLeftImage() {
  const parent = document.querySelector('.ingredients-section--wrapper');
  if (!parent) return;
  const selectedTab = parent.querySelector(
    '.ingredients-content--wrapper .toggle--wrapper .tab--toggle.tab-selected'
  );
  if (!selectedTab) return;
  const groupId = selectedTab.getAttribute('data-group-id');

  const imagesParent = parent.querySelectorAll('.ing-image--wrap');
  let selectedImage = null;

  imagesParent.forEach((image) => {
    if (image.getAttribute('data-group-id') === groupId) {
      image.classList.add('visible', 'transitioned');
      selectedImage = image;
    } else {
      image.classList.remove('visible', 'transitioned');
    }
  });

  if (!selectedImage && imagesParent.length > 0) {
    imagesParent[0].classList.add('visible', 'transitioned');
  }
}

function initToggles() {
  initProductsPanels();
  initIngredientPanels();
  updateLeftImage();
}

document.addEventListener('DOMContentLoaded', initToggles);

// ----------------------------------------------------------------------------------------

// Animated Chart Sections

// ----------------------------------------------------------------------------------------

function initChartAnimationSections() {
  const pieCharts = document.querySelectorAll('[data-pie]');
  if (pieCharts.length === 0) return;

  const preferReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  const pieChartObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((chart) => {
        if (chart.isIntersecting) {
          let speed = +chart.target.dataset.speed || 0;
          preferReducedMotion && (speed = 0);
          const delay = +chart.target.dataset.delay || 0;
          const percent = +chart.target.dataset.percent || 0;
          const percentColor = chart.target.dataset.percentColor || '';
          const labelColor = chart.target.dataset.labelColor || '';
          const label = chart.target.dataset.label || '';
          const labelPosition = chart.target.dataset.labelPosition || '';
          const circle = chart.target.querySelector('circle');
          const text = chart.target
            .closest('div')
            .querySelector('.percent-text');
          /*if (label != '') {
                      if (labelPosition == 'top') {
                          document.querySelector('.percent-text').innerHTML = `<tspan x="0" dy="-0.7em" style="font-size: 0.6em; text-transform: uppercase;" fill="${labelColor}">${label}</tspan><tspan x="0" dy="0.75em" style="font-size: 1.2em;" fill="${percentColor}">${percent}%</tspan>`;
                      } else {
                          document.querySelector('.percent-text').innerHTML = `<tspan x="0" dy="-0.1em" style="font-size: 1.2em;" fill="${percentColor}">${percent}%</tspan><tspan x="0" dy="1.3em" style="font-size: 0.6em; text-transform: uppercase;" fill="${labelColor}">${label}</tspan>`;
                      }
                  }
                  else {
                      document.querySelector('.percent-text').innerHTML = `<tspan dy="0.1em" style="font-size: 1.5em;"  fill="${percentColor}">${percent}%</tspan>`
                  }*/
          chart.target.setAttribute(
            'aria-label',
            `${percent} percent pie chart`
          );
          circle.animate(
            [
              {
                strokeDashoffset: 100
              },
              {
                strokeDashoffset: 100 - percent
              }
            ],
            {
              duration: speed,
              easing: 'cubic-bezier(0.57,-0.04, 0.41, 1.13)',
              fill: 'forwards'
            }
          );
          text.animate(
            [
              {
                opacity: 0,
                transform: 'translateY(20%)'
              },
              {
                opacity: 1,
                transform: 'translateY(0%)'
              }
            ],
            {
              delay: preferReducedMotion ? 0 : delay,
              duration: preferReducedMotion ? 0 : 300,
              easing: 'cubic-bezier(0.57,-0.04, 0.41, 1.13)',
              fill: 'forwards'
            }
          );
          pieChartObserver.unobserve(chart.target);
        }
      });
    },
    {
      threshold: 0.8
    }
  );

  pieCharts.forEach((chart) => {
    pieChartObserver.observe(chart);
  });
}

document.addEventListener('DOMContentLoaded', initChartAnimationSections);

// ----------------------------------------------------------------------------------------

// Countdown Components

// ----------------------------------------------------------------------------------------

function initCountdownComponents() {
  const countdowns = document.querySelectorAll(
    '[data-content="countdown-timer"]'
  );
  if (countdowns.length === 0) return;

  countdowns.forEach((countdown) => {
    handleCountdown(countdown);
  });
}

function handleCountdown(parent) {
  let endDate = parent.getAttribute('data-end-date');
  let endTime = parent.getAttribute('data-end-time');
  if (!endDate || !endTime) return;

  // Combine the date and time into one string
  let combinedDateTimeString = `${endDate}T${endTime}`;

  // Convert the combined string to a specific time zone using Moment Timezone
  let endDateTime = moment.tz(combinedDateTimeString, 'America/New_York'); // Use the desired time zone here

  function updateCountdown() {
    let now = moment();

    // Calculate the time difference between now and the target date
    let timeLeft = endDateTime.diff(now);

    if (timeLeft > 0) {
      let duration = moment.duration(timeLeft);
      let daysLeft = Math.floor(duration.asDays());
      let hoursLeft = duration.hours();
      let minutesLeft = duration.minutes();
      let secondsLeft = duration.seconds();

      const daysDisplay = parent.querySelector(
        '[data-content="countdown-days"]'
      );
      if (daysDisplay) {
        daysDisplay.textContent = daysLeft;
      }
      parent.querySelector('[data-content="countdown-hours"]').textContent =
        hoursLeft;
      parent.querySelector('[data-content="countdown-minutes"]').textContent =
        minutesLeft;
      parent.querySelector('[data-content="countdown-seconds"]').textContent =
        secondsLeft;

      if (!parent.classList.contains('transitioned')) displayCountdown(parent);
    } else {
      parent.remove();
    }
  }

  setInterval(updateCountdown, 1000);
  setTimeout(() => {
    parent.classList.remove('opacity--hidden');
  }, 1000);
}

function displayCountdown(target) {
  target.style.height = target.scrollHeight + 'px';
  target.classList.add('transition');
  setTimeout(function () {
    target.classList.add('transitioned');
    target.classList.remove('transition');
    target.style.height = 'auto';
  }, 250);
}

document.addEventListener('DOMContentLoaded', initCountdownComponents);

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initCountdownComponents();
  });
}

// ----------------------------------------------------------------------------------------

// Video with Animated Text Sections

// ----------------------------------------------------------------------------------------

function initVideoTextAnimations() {
  const sections = document.querySelectorAll(
    '[data-section-type="video-with-animated-text"]'
  );
  if (sections.length === 0) return;

  sections.forEach((section) => {
    enableVideoTextAnimation(section, parseVideoAnimationSettings(section));
  });
}

function handleDelay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function parseBlankWidth(section, texts) {
  let maxWidth = 0;
  let ruler = section.querySelector('[data-content="width-setter"]');
  texts.forEach((text) => {
    ruler.textContent = text;
    if (ruler.offsetWidth > maxWidth) maxWidth = ruler.offsetWidth;
  });

  return (maxWidth += 40);
}

function setBlankWidth(element, value) {
  element.style.width = `${value}px`;
  element.classList.remove('opacity--hidden');
}

function enableVideoTextAnimation(section, settings) {
  const { video, textWrapper, texts, textDuration, transitionDuration } =
    settings;
  const adjustedTransition = textDuration - transitionDuration * 2;

  const widthSetter = section.querySelector('[data-content="width-setter"]');
  const borderEl = section.querySelector('[data-content="border-element"]');

  if (widthSetter && borderEl) {
    setBlankWidth(borderEl, parseBlankWidth(section, texts));
    window.addEventListener('resize', () => {
      setBlankWidth(borderEl, parseBlankWidth(section, texts));
    });
  }

  video.addEventListener('play', async () => {
    for (let i = 0; i < texts.length; i++) {
      const lastOption = i === texts.length - 1;

      let lastVisible;
      if (lastOption) {
        lastVisible =
          video.duration - video.currentTime - transitionDuration * 2;
      }
      textWrapper.textContent = texts[i];
      textWrapper.classList.remove('transition-out');
      await handleDelay(transitionDuration);
      textWrapper.classList.add('transitioned');
      if (!lastOption) {
        await handleDelay(adjustedTransition);
        textWrapper.classList.remove('transitioned');
        textWrapper.classList.add('transition-out');
        await handleDelay(transitionDuration);
      }
    }
  });

  video.addEventListener('ended', () => {
    video.play();
  });

  setTimeout(() => {
    video.play();
  }, transitionDuration);
}

function parseVideoAnimationSettings(section) {
  const video = section.querySelector('video');
  const textWrapper = section.querySelector(
    '.animated-text--display:not(.disable--animation)'
  );

  //if (!video || !textWrapper) return;

  const texts = textWrapper.getAttribute('data-animation-text').split(`~`);

  const textDuration =
    parseInt(section.getAttribute('data-text-duration')) || 2500;
  const inputTransitionDuration =
    parseInt(section.getAttribute('data-transition-duration')) || 100;
  const transitionDuration =
    inputTransitionDuration < textDuration / 2
      ? inputTransitionDuration
      : inputTransitionDuration * 0.1;

  return {
    video: video,
    textWrapper: textWrapper,
    texts: texts,
    textDuration: textDuration,
    transitionDuration: transitionDuration
  };
}

document.addEventListener('DOMContentLoaded', initVideoTextAnimations);

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initVideoTextAnimations();
  });
}

// ----------------------------------------------------------------------------------------

// Hideable Announcement Bars

// ----------------------------------------------------------------------------------------

function initAnnouncementNotifications() {
  const announcements = document.querySelectorAll(
    '[data-content="closable-announcement"]'
  );
  if (announcements.length === 0) return;

  announcements.forEach((announcement) => {
    const closeButton = announcement.querySelector(
      '[data-action="remove-section"]'
    );
    if (!closeButton) return;

    closeButton.addEventListener('click', closeBar);
  });
}

function closeBar() {
  const parent = this.closest('.announce--parent');
  parent.style.marginBottom = `-${parent.offsetHeight}px`;
  parent.style.opacity = 0;

  setTimeout(() => {
    parent.remove();
  }, 250);
}

document.addEventListener('DOMContentLoaded', initAnnouncementNotifications);

// --------------------------------------------
// Pet Profiles / Cart Attributes Sync + Checks
// --------------------------------------------

async function handleCartSync(attributesJson) {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: attributesJson
    })
  })
    .then((response) => response.json())
    .then((data) => {
      localStorage.removeItem('customerCartSync');
      localStorage.removeItem('customerCartSyncAttributes');
    })
    .catch((error) => {
      console.error('Error updating cart attributes:', error);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  if (
    localStorage.getItem('customerCartSync') &&
    localStorage.getItem('customerCartSyncAttributes')
  ) {
    handleCartSync(
      JSON.parse(localStorage.getItem('customerCartSyncAttributes'))
    );
  }
});

// ----------------------------------------------------------------------------------------

// FFD Mini Quiz

// ----------------------------------------------------------------------------------------

const MER_TRANSFORM = 0.84;
const GRAMS_PER_LB = 28.3495 * 16;
const SERVING_UNIT_DIVIDER = 8;
const DEFAULT_INTERVAL = 1;
const DEFAULT_INTERVAL_FRESH = 2;
const MEALS_PER_DAY = 2;

let nutritionByFlavor;

const formStates = {
  recommendation_applied: true
};

const sizeGroupWeightLimits = {
  small: 25,
  medium: 60,
  large: 100,
  giant: 999
};

const sizeGroupLifestageLimits = {
  small: {
    young_puppy: 5,
    puppy: 9,
    adult: 133,
    senior: 999
  },
  medium: {
    young_puppy: 5,
    puppy: 9,
    puppy_teen: 11,
    adult: 109,
    senior: 999
  },
  large: {
    young_puppy: 5,
    puppy: 9,
    puppy_teen: 12,
    adult: 85,
    senior: 999
  },
  giant: {
    young_puppy: 5,
    puppy: 9,
    puppy_teen: 24,
    adult: 73,
    senior: 999
  }
};

const ffdFlavors = ['chicken', 'beef'];

const ffdFlavorNutritionData = {
  chicken: {
    kcal_gram: 5.05,
    density: 76
  },
  beef: {
    kcal_gram: 4.6,
    density: 76
  }
};

const valueDisplayTransforms = {
  age: (value) => {
    return value < 12
      ? `${value} month${value > 1 ? 's' : ''}`
      : `${value - 11} year${value - 11 > 1 ? 's' : ''}`;
  },
  weight: (value) => {
    return `${value} lb${value > 1 ? 's' : ''}`;
  },
  frequency: (value) => {
    if (value === 1) return 'week';
    return `${value} weeks`;
  },
  bags: (value) => {
    return `${value} bag${value > 1 ? 's' : ''}`;
  },
  lbs: (value) => {
    return `${value} lb${value > 1 ? 's' : ''}`;
  }
};

const valueDataTransforms = {
  // Returns age in months
  age: (value) => {
    return value < 13 ? value : (value - 11) * 12;
  },
  rer: (weight) => {
    const metabolicWeight = (weight / 2.2) ** 0.75;
    return metabolicWeight * 70;
  },
  mer: (rer, factor) => {
    return rer * factor * MER_TRANSFORM;
  },
  interval_meals: (interval) => {
    return interval * 7 * MEALS_PER_DAY;
  },
  bag_size: (value) => {
    return value.includes('16') ? 1 : 2;
  },
  birthday: (ageMonths) => {
    const now = new Date();
    const birthDate = new Date(now.setMonth(now.getMonth() - ageMonths));
    const birthMonth = birthDate.getMonth() + 1; // getMonth() returns 0-11, so add 1 for 1-12
    const birthYear = birthDate.getFullYear();
    return {
      birthday_month: birthMonth,
      birthday_year: birthYear
    };
  }
};

function findKeyWithMaxValue(value, lookup) {
  // Convert the object into an array of entries [key, value]
  const entries = Object.entries(lookup);
  // Filter for entries where the value is greater than the input
  const validEntries = entries.filter(([key, limit]) => limit > value);
  // Find the entry with the smallest weight limit
  const [resultKey] = validEntries.reduce((smallest, current) => {
    return current[1] < smallest[1] ? current : smallest;
  }, validEntries[0]);

  return resultKey;
}

function updateValueDisplay(source, target) {
  const displayValue = valueDisplayTransforms[source.id]
    ? valueDisplayTransforms[source.id](parseInt(source.value))
    : source.value;

  target.textContent = displayValue;
}

function initRangeInputListeners(type) {
  const rangeTriggers = document.querySelectorAll(
    'input[type="range"][data-calc-input]'
  );
  rangeTriggers.forEach((trigger) => {
    const valueDisplay = document.querySelector(
      `[data-content="range-value"][data-value-for="${trigger.id}"]`
    );
    const form = trigger.closest('form');
    trigger.addEventListener('input', () => {
      if (type === 'ffd') {
        resetResultsDisplay(form);
      }
      updateValueDisplay(trigger, valueDisplay);
    });
    trigger.addEventListener('change', () => handleCalcs(form, false, type));
  });
}

function initCalculationTrigger() {
  const forms = document.querySelectorAll(
    'form[data-action="generate-results"]'
  );
  forms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      handleCalcs(form, true, 'ffd');
    });
  });
}

const miniQuizPropFields = {
  ffd: [
    {
      name: 'properties[_calculated_birthday_month]',
      value_key: 'calculated_birthday.birthday_month',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_calculated_birthday_year]',
      value_key: 'calculated_birthday.birthday_year',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_weight]',
      value_key: 'weight',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_life_stage]',
      value_key: 'life_stage',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_daily_calories_required]',
      value_key: 'nutrition.mer',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_meal_calories_required]',
      value_key: 'nutrition.meal_calories',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_meal_calories_provided]',
      value_key: 'calories_per_meal',
      type: 'hidden',
      source: 'meal'
    },
    {
      name: 'properties[_lbs_per_delivery]',
      value_key: 'lbs_per_delivery',
      type: 'hidden',
      source: 'meal'
    },
    {
      name: 'properties[_lbs_per_week]',
      value_key: 'lbs_per_delivery',
      type: 'hidden',
      source: 'meal'
    },
    {
      name: 'properties[_delivery_frequency]',
      value_key: 'interval_frequency',
      type: 'hidden',
      source: 'meal'
    }
  ],
  fresh: [
    {
      name: 'properties[_calculated_birthday_month]',
      value_key: 'calculated_birthday.birthday_month',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_calculated_birthday_year]',
      value_key: 'calculated_birthday.birthday_year',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_weight]',
      value_key: 'weight',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_life_stage]',
      value_key: 'life_stage',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_daily_calories_required]',
      value_key: 'nutrition.mer',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_meal_calories_required]',
      value_key: 'nutrition.meal_calories',
      type: 'hidden',
      source: 'dog'
    },
    {
      name: 'properties[_meal_calories_provided]',
      value_key: 'calories_per_meal',
      type: 'hidden',
      source: 'meal'
    },
    {
      name: 'properties[_delivery_frequency]',
      value_key: 'interval_frequency',
      type: 'hidden',
      source: 'meal'
    }
  ]
};

function handleCustomPropsUpdate(form, dogData, mealData, type) {
  const parent = form.closest('.product-single__meta');
  const addButton = parent.querySelector('button[type="submit"][name="add"]');
  const addForm = addButton.closest('form');
  const addFields = !addForm.querySelector(
    'input[name="properties[_calculated_birthday_month]"]'
  );

  if (addFields) {
    handlePropFieldAddition(addForm, dogData, mealData, type);
  }

  handlePropFieldUpdate(addForm, dogData, mealData, type);
}

function handlePropFieldAddition(form, dogData, mealData, type) {
  miniQuizPropFields[type].forEach((field) => {
    const source = field.source === 'dog' ? dogData : mealData;
    if (!source) return;

    const input = document.createElement('input');
    if (!input) return;

    input.type = field.type;
    input.name = field.name;
    form.appendChild(input);
  });
}

function handlePropFieldUpdate(form, dogData, mealData, type) {
  miniQuizPropFields[type].forEach((field) => {
    const source =
      field.source === 'dog'
        ? dogData
        : type === 'fresh'
          ? mealData.find(
              (meal) =>
                meal.variant_id ===
                parseCurrentSelection(form.dataset.productid).id
            )
          : mealData;
    if (!source) return;

    const input = form.querySelector(`input[name="${field.name}"]`);
    if (!input) return;

    const transformer =
      field.name === 'properties[_lbs_per_week]'
        ? 1 / mealData.interval_frequency
        : 1;
    const parentKey = field.value_key.split('.')[0];
    const childKey =
      field.value_key.split('.').length > 1
        ? field.value_key.split('.')[1]
        : null;

    if (!childKey) {
      const value =
        transformer !== 1
          ? parseFloat((source[parentKey] * transformer).toFixed(2))
          : source[parentKey];
      input.value = value;
      return;
    } else {
      const value =
        transformer !== 1
          ? parseFloat((source[parentKey][childKey] * transformer).toFixed(2))
          : source[parentKey][childKey];
      input.value = value;
      return;
    }
  });
}

function parsePackSizes(dogData, form) {
  // console.log('dogData: ', dogData);
  let matchedSizes = [];
  Object.keys(nutritionByFlavor).forEach((flavor) => {
    let closestSize = null;
    let closestSizeDisplay = null;
    let closestSizePrice = null;
    let closestCaloriesDiff = Infinity;
    let closestVariantId = null;
    let closestCaloriesPerMeal = null;
    nutritionByFlavor[flavor].sizes.forEach((sizeOption) => {
      const calorieDiff = Math.abs(
        sizeOption.calories_per_meal - dogData.nutrition.meal_calories
      );
      if (calorieDiff < closestCaloriesDiff) {
        closestCaloriesDiff = calorieDiff;
        closestSizePrice = sizeOption.price;
        closestSize = sizeOption.size;
        closestSizeDisplay = sizeOption.size_display;
        closestVariantId = sizeOption.variant_id;
        closestCaloriesPerMeal = sizeOption.calories_per_meal;
      }
    });
    matchedSizes.push({
      flavor,
      size: closestSize,
      size_display: closestSizeDisplay,
      unit_price: closestSizePrice,
      variant_id: closestVariantId,
      calories_per_meal: closestCaloriesPerMeal,
      interval_frequency: getCurrentInterval(form, 'fresh')
    });
  });

  return matchedSizes;
}

function handleFreshMealSelection(form, mealData) {
  const parent = form.closest('.product-single__meta');
  mealData.forEach((option) => {
    const shadowInput = parent.querySelector(
      `[data-shadow-input-group][data-value="shadow-${option.flavor}"]`
    );
    const input = shadowInput.querySelector('input');
    input.setAttribute('data-active-size', option.size_display);
    input.setAttribute('data-active-price', option.unit_price);
    input.setAttribute('data-active-variant', option.variant_id);
  });

  mealData.forEach((option) => {
    const shadowInput = parent.querySelector(
      `[data-shadow-input-group][data-value="shadow-${option.flavor}"]`
    );
    const input = shadowInput.querySelector('input');
    if (input.checked) {
      const flavorVariantInput = parent.querySelector(
        `input[type="radio"][name="Flavor"][value="${shadowInput.dataset.valueString}"]`
      );
      if (flavorVariantInput && !flavorVariantInput.checked) {
        flavorVariantInput.checked = true;
      }
      const sizeVariantInput = parent.querySelector(
        `input[type="radio"][name="Size"][value="${option.size_display}"]`
      );
      if (sizeVariantInput) {
        sizeVariantInput.nextElementSibling.click();
        return;
      }
    }
  });
}

function handleCalcs(form, handleDisplay, type = 'ffd') {
  const dogData = parseDogData(form);
  const mealData =
    type === 'ffd'
      ? parseMealLbs(dogData, form)
      : parsePackSizes(dogData, form);

  if (type === 'fresh') {
    handleFreshMealSelection(form, mealData);
  } else if (type === 'ffd') {
    updateResultsPanelContent(form, mealData);
    if (handleDisplay) {
      handleResultsDisplay(form);
    }
  }

  handleCustomPropsUpdate(form, dogData, mealData, type);
}

function initVariantListeners(type) {
  const selectors = document.querySelectorAll(
    '[data-variant-input], input[data-toggles="autoship"], select[name="selling_plan"]'
  );
  selectors.forEach((selector) => {
    const section = selector.closest('[data-section-type="product"]');
    const form = section.querySelector('form[data-action="generate-results"]');
    if (!form) return;
    selector.addEventListener('change', () => handleCalcs(form, false, type));
  });
}

function handleResultsDisplay(form) {
  if (!form) return;

  const blockResultsDisplay = form
    .closest('.product-block')
    .querySelector('[data-content="inline-results-display"]');
  const resultsDisplay = form.querySelector('[data-content="results-display"]');
  if (!resultsDisplay && !blockResultsDisplay) return;

  if (blockResultsDisplay) {
    blockResultsDisplay.classList.remove('hidden');
  }

  if (resultsDisplay) {
    resultsDisplay.classList.add('visible');
    setTimeout(() => {
      resultsDisplay.classList.add('transitioned');
    }, 50);
  }
}

function resetResultsDisplay(form) {
  if (!form) return;

  const resultsDisplay = form.querySelector('[data-content="results-display"]');
  if (!resultsDisplay) return;

  resultsDisplay.classList.remove('visible');
  resultsDisplay.classList.remove('transitioned');
}

function updateResultsPanelContent(form, mealData) {
  if (!form) return;
  const block = form.closest('.product-block')
    ? form.closest('.product-block')
    : form;

  block
    .querySelectorAll('[data-content="bags-per-interval"]')
    .forEach((element) => {
      element.textContent = valueDisplayTransforms.lbs(
        mealData.lbs_per_delivery
      );
    });
  block
    .querySelectorAll('[data-content="interval-frequency"]')
    .forEach((element) => {
      element.textContent = valueDisplayTransforms.frequency(
        mealData.interval_frequency
      );
    });
}

function parseMealLbs(dogData, form) {
  const section = form.closest('[data-section-type="product"]');
  const selectedFlavor = section
    .querySelector('input[type="radio"][name="Flavor"]:checked')
    .value.toLowerCase();
  const selectedSize = section
    .querySelector('input[type="radio"][name="Bag size"]:checked')
    .value.toLowerCase();
  const sizeDivider = valueDataTransforms.bag_size(selectedSize);
  // TODO: Add handling for selectedFlavor not found
  const flavorNutrition = nutritionByFlavor[selectedFlavor];
  const mealServingUnits = parseServingNutrition(
    dogData.nutrition.meal_calories,
    flavorNutrition,
    form,
    sizeDivider
  );

  return mealServingUnits;
}

function parseServingNutrition(mealCalories, nutrition, form, sizeDivider) {
  const servingsPerMeal = parseMealServingUnits(
    mealCalories,
    nutrition.calories_per_serving_unit
  );
  const currentInterval = getCurrentInterval(form);
  const mealsPerInterval =
    valueDataTransforms['interval_meals'](currentInterval);
  const servingsPerInterval =
    (servingsPerMeal * mealsPerInterval) / sizeDivider;
  const lbsPerInterval = Math.max(
    1,
    Math.ceil(servingsPerInterval / nutrition.serving_units_per_lb)
  );
  return {
    servings_per_meal: servingsPerMeal,
    calories_per_meal: servingsPerMeal * nutrition.calories_per_serving_unit,
    cups_per_meal: servingsPerMeal / SERVING_UNIT_DIVIDER,
    lbs_per_delivery: lbsPerInterval,
    interval_frequency: currentInterval
  };
}

function getCurrentInterval(form, type = 'ffd') {
  const autoshipSelected = checkSubscriptionEnabled(form);
  if (!autoshipSelected)
    return type === 'ffd' ? DEFAULT_INTERVAL : DEFAULT_INTERVAL_FRESH;
  if (
    document.querySelector(
      'input[type="checkbox"][name="selling_plan"]:checked'
    )
  ) {
    return parseInt(
      document.querySelector(
        'input[type="checkbox"][name="selling_plan"]:checked'
      ).dataset.sellingPlanValue
    );
  }

  const frequencySelect = document.querySelector('select[name="selling_plan"]');
  if (frequencySelect) {
    const selectedFrequencyOption =
      frequencySelect.options[frequencySelect.selectedIndex];
    if (selectedFrequencyOption) {
      return parseInt(selectedFrequencyOption.dataset.optionFrequency);
    }
  }
  return type === 'ffd' ? DEFAULT_INTERVAL : DEFAULT_INTERVAL_FRESH;
}

function checkSubscriptionEnabled(form) {
  return form.querySelector('[name="selling_plan"]:checked') ||
    document.querySelector('input[value="autoship"]:checked')
    ? true
    : false;
}

function parseMealServingUnits(mealCalories, calsPerServingUnit) {
  const servingsPerMeal = Math.max(
    1,
    Math.floor(mealCalories / calsPerServingUnit)
  );
  // If serving size is 6 or less, or the servingsPerMeal value is not odd, we're done.
  if (servingsPerMeal <= 6 || servingsPerMeal % 2 === 0) return servingsPerMeal;
  // Otherwise, needs to be rounded to the closest even caloric match
  const plusCompare = Math.abs(
    (servingsPerMeal + 1) * calsPerServingUnit - mealCalories
  );
  const minusCompare = Math.abs(
    (servingsPerMeal - 1) * calsPerServingUnit - mealCalories
  );

  return plusCompare < minusCompare ? servingsPerMeal + 1 : servingsPerMeal - 1;
}

function parseFlavorNutrition(type) {
  if (type === 'ffd') {
    const ffdFlavorNutrition = {};
    ffdFlavors.forEach((flavor) => {
      const caloriesPerLb =
        GRAMS_PER_LB * ffdFlavorNutritionData[flavor].kcal_gram;
      const cupsPerLb = GRAMS_PER_LB / ffdFlavorNutritionData[flavor].density;
      const caloriesPerCup = caloriesPerLb / cupsPerLb;
      const caloriesPerServingUnit = caloriesPerCup / SERVING_UNIT_DIVIDER;
      const servingUnitsPerLb = caloriesPerLb / caloriesPerServingUnit;
      ffdFlavorNutrition[flavor] = {
        calories_per_lb: caloriesPerLb,
        cups_per_lb: cupsPerLb,
        calories_per_cup: caloriesPerCup,
        calories_per_serving_unit: caloriesPerCup / SERVING_UNIT_DIVIDER,
        serving_units_per_lb: servingUnitsPerLb
      };
    });

    return ffdFlavorNutrition;
  }
  const rawFreshNutrition = JSON.parse(
    document.querySelector('[data-content="fresh-flavor-nutrition"]')
      .textContent
  );
  const freshFlavorNutrition = {};

  rawFreshNutrition.forEach((variant) => {
    if (freshFlavorNutrition[variant.variant_flavor]) {
      freshFlavorNutrition[variant.variant_flavor].sizes.push({
        size: variant.variant_size,
        size_display: variant.variant_size_display,
        calories_per_meal: variant.variant_size * variant.kcal_gram,
        price: variant.variant_price,
        variant_id: variant.variant_id
      });
    } else {
      freshFlavorNutrition[variant.variant_flavor] = {
        sizes: [
          {
            size: variant.variant_size,
            size_display: variant.variant_size_display,
            calories_per_meal: variant.variant_size * variant.kcal_gram,
            price: variant.variant_price,
            variant_id: variant.variant_id
          }
        ]
      };
    }
  });
  return freshFlavorNutrition;
}

function parseDogData(form) {
  const userInputs = parseInputValues(
    form.querySelectorAll('[data-calc-input]')
  );
  const dogDetails = parseDogDetails(userInputs);
  const nutrition = parseNutrition(userInputs, dogDetails);
  const calculatedBirthday = valueDataTransforms.birthday(userInputs.age);

  return {
    weight: userInputs.weight,
    age: userInputs.age,
    calculated_birthday: calculatedBirthday,
    size_group: dogDetails.size_group,
    life_stage: dogDetails.life_stage,
    nutrition
  };
}

function parseInputValues(inputs) {
  const values = {};
  inputs.forEach((input) => {
    if (input.type === 'range') {
      values[input.id] = valueDataTransforms[input.id]
        ? valueDataTransforms[input.id](parseInt(input.value))
        : parseInt(input.value);
    }
  });
  return values;
}

function parseDogDetails(userInputs) {
  const { age, weight } = userInputs;
  const sizeGroup = parseSizeGroupEstimate(age, weight);
  const lifeStage = parseLifeStage(age, sizeGroup);

  return {
    size_group: sizeGroup,
    life_stage: lifeStage
  };
}

function parseSizeGroupEstimate(age, weight) {
  if (weight > 99) {
    // Because we don't acticipate a dog shrinking
    return 'giant';
  }
  if (weight < 25 && age >= 9) {
    // Because we don't anticipate significant growth from here
    return 'small';
  }
  if (age < 9) {
    // Because size group doesn't matter this young
    return 'medium';
  }
  const sizeGroup = findKeyWithMaxValue(weight, sizeGroupWeightLimits);
  if (
    findKeyWithMaxValue(age, sizeGroupLifestageLimits[sizeGroup]) !==
    'puppy_teen'
  ) {
    return sizeGroup;
  }
  // If puppy teen lifestage, we may need to adjust the size group if weight within 15% of upper limit.
  return findKeyWithMaxValue(weight * 1.15, sizeGroupWeightLimits);
}

function parseLifeStage(age, sizeGroup) {
  return findKeyWithMaxValue(age, sizeGroupLifestageLimits[sizeGroup]);
}

function parseNutrition(userInputs, dogDetails) {
  const { age, weight } = userInputs;
  const { size_group, life_stage } = dogDetails;

  const factorKey = life_stage.includes('puppy')
    ? life_stage
    : `${life_stage}_fixed`;

  const rer = valueDataTransforms.rer(weight);
  const mer = valueDataTransforms.mer(rer, rerMultipliers[factorKey]);
  return {
    rer,
    mer,
    meal_calories: mer / 2
  };
}

document.addEventListener('DOMContentLoaded', () => {
  if (
    document.querySelector('[data-modal-id="ffd-quantity-helper"') ||
    document.querySelector('[data-content="fresh-mini-quiz"]')
  ) {
    const type = document.querySelector('[data-content="fresh-mini-quiz"]')
      ? 'fresh'
      : 'ffd';
    nutritionByFlavor = parseFlavorNutrition(type);
    initVariantListeners(type);
    initRangeInputListeners(type);
    if (type === 'ffd') {
      initCalculationTrigger();
    }
  }
});
